"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSchemeCallback;

/**
 * @file createSchemeCallback.js
 */

/**
 * 生成端能力调用的全局函数
 * @param callbackFn 真正回调的函数
 * @param isNoDeleteFn 是否删除全局函数
 * @return {string} 全局函数名
 */
function createSchemeCallback(callbackFn, isNoDeleteFn) {
  var windowFnName = "__RMB_QUANMIN__".concat(new Date().getTime());

  window[windowFnName] = function (data) {
    var res = {};

    try {
      res = typeof data === 'string' ? JSON.parse(data) : data;
    } catch (e) {
      callbackFn(data);
    }

    if (callbackFn instanceof Function) {
      callbackFn(res);
    }

    if (!isNoDeleteFn) {
      // 删除全局函数
      delete window[windowFnName];
    }
  };

  return windowFnName;
}